import keyMirror from 'fbjs/lib/keyMirror';

/**
 * @constant {Object} ApplicationConstants
 * @memberof Application
 */
export const WorkflowConstants = keyMirror({
  SIGNIN_ACTION: undefined,
  SIGNOUT_ACTION: undefined,
  UPDATEBALANCE_ACTION: undefined,
  EARNDEPOSIT_ACTION: undefined,
  DEPOSITSEND_ACTION: undefined,
  GET_IP_ADDRESS: undefined,
});
